import InProcess from "./InProcess";
import Rejected from "./Rejected";
import Pending from "./Pending"

export default {InProcess,Rejected,Pending} 